module.exports = __webpack_public_path__ + "static/media/MEMBERS_ONLY_60X50.ee9ef2de.svg";